<div class="layout-topbar">

    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
    </button>

    <a class="layout-topbar-logo" [routerLink]="['/home']">
        <img src="assets/layout/images/Dow-Waste.png" alt="logo">
    </a>
    
    <img src="assets/layout/images/DOW_&_JV_Logo.png" alt="Logo" height="45" class="topbar-logo"/>

    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button"
        (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>

    <div #topbarmenu class="layout-topbar-menu"
        [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
        <p-menu #menu [popup]="true" [model]="menuItems" appendTo="body"></p-menu>
        <i class="p-link pi pi-megaphone mx-4 p-text-secondary icon-mobile" *ngIf="isAdmin || isDisposer"
            [routerLink]="'/acknownledgment'" style="font-size: 1.5rem"></i>
        <div class="" *ngIf="isAdmin || isDisposer">|</div>
        <!--  -->
            @if (loadingNoti) {
                <i [class.fa-spinner]="loadingNoti" class="fa mx-4"
                        [ngClass]="{'fa-spin': loadingNoti}" style="font-size: 1.5em"></i>
            } @else {
                <i class="p-link pi pi-bell mx-4 p-text-secondary icon-mobile" pBadge style="font-size: 1.5rem" [value]="badgeValue"
                severity="danger" (click)="loadNotification()"></i>
            }
            
        <div class="">|</div>

        <div class="p-link" (click)="menu.toggle($event)"><i class="p-link pi ml-4 mr-1 pi-user icon-mobile"
                style="font-size: 1.5rem"></i><span>{{userInfo}}</span></div>
        <div class="ml-4">|</div>
        <i class="p-link pi mx-4 pi-sign-out" style="font-size: 1.5rem" (click)="logout()"></i>
    </div>
</div>

<div class="notification-panel" *ngIf="showNotificationPanel" #notificationBox>
    <div class="container-notifications">
        <div class="card-body">
            <div class="notification-header">
                <p class="notification-title">
                    Notifications
                    <!-- <span class="badge badgeBackground">{{notificationsNum}}</span> -->
                </p>
                <!-- <p class="mark-all-read" (click)="read()">Mark all as read</p> -->
            </div>
            <div class="row p-1">
                <div class="notification-card link" *ngFor="let noti of notificationData">
                    <span class="close-btn" (click)="deleteNotification(noti)">&times;</span>
                    <span *ngIf="!noti.isRead" class="badge bg-danger">New</span>
                    <div class="notification-content mt-1" 
                        [ngClass]="{'pointer': noti.isLink || !noti.isRead}" 
                        (click)="handleNotificationClick(noti)">
                        <p>{{ noti.message }}</p>
                        <div class="notification-date">
                            <i class="pi pi-clock"></i>
                            <span> <b>{{ noti.date }}</b></span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>




<!-- Change Email Dialog -->
<p-dialog header="Change Email" [(visible)]="displayChangeEmail" [modal]="true" [closable]="true"
    [style]="{width: '50vw'}" (onHide)="onCancelEmail()">
    <div class="p-fluid">
        <form [formGroup]="emailForm" (ngSubmit)="onSubmitEmail()">
            <div class="p-field">
                <label for="email">Email</label>
                <input id="email" type="email" pInputText formControlName="email" placeholder="Enter email" />
                <div *ngIf="emailForm.get('email').invalid && emailForm.get('email').touched">
                    <small class="p-error" *ngIf="emailForm.get('email').errors.required">Email is required.</small>
                    <small class="p-error" *ngIf="emailForm.get('email').errors.email">Invalid email format.</small>
                </div>
            </div>
        </form>
    </div>
    <p-footer>
        <button type="submit" pButton icon="pi pi-check" label="Comfirm" [disabled]="emailForm.invalid"
            (click)="onSubmitEmail()"></button>
        <button type="button" pButton icon="pi pi-times" label="Cancel" class="p-button-danger"
            (click)="onCancelEmail()"></button>
    </p-footer>
</p-dialog>

<!-- Change Password Dialog -->
<p-dialog header="Change Password" [(visible)]="displayChangePassword" [modal]="true" [closable]="true"
    [style]="{width: '50vw'}" (onHide)="onCancelPassword()">
    <div class="p-fluid">
        <form [formGroup]="passwordForm" (ngSubmit)="onSubmitPassword()">
            <div class="p-field">
                <label for="oldPassword">Old Password</label>
                <!-- <input id="oldPassword" type="password" pInputText formControlName="oldPassword" /> -->
                <p-password formControlName="oldPassword" [toggleMask]="true" [feedback]="false"
                    [placeholder]="'Enter your old password'"></p-password>
                <div *ngIf="passwordForm.get('oldPassword').invalid && passwordForm.get('oldPassword').touched">
                    <small class="p-error">Old Password is required.</small>
                </div>
            </div>
            <div class="p-field">
                <label for="newPassword">New Password</label>
                <!-- <input id="newPassword" type="password" pInputText formControlName="newPassword" /> -->
                <p-password formControlName="newPassword" [toggleMask]="true" [feedback]="false"
                    [placeholder]="'Enter your new password'"></p-password>
                <div *ngIf="passwordForm.get('newPassword').invalid && passwordForm.get('newPassword').touched">
                    <small class="p-error">New Password is required.</small>
                </div>
            </div>
            <div class="p-field">
                <label for="confirmNewPassword">Confirm New Password</label>
                <p-password formControlName="confirmNewPassword" [toggleMask]="true" [feedback]="false"
                    [placeholder]="'Enter your confirm new password'"></p-password>
                <!-- <input id="confirmNewPassword" type="password" pInputText formControlName="confirmNewPassword" /> -->
                <div
                    *ngIf="passwordForm.get('confirmNewPassword').invalid && passwordForm.get('confirmNewPassword').touched">
                    <small class="p-error">Confirm New Password is required.</small>
                </div>
            </div>
        </form>
    </div>
    <p-footer>
        <button type="submit" pButton icon="pi pi-check" label="Confirm" [disabled]="passwordForm.invalid"
            (click)="onSubmitPassword()"></button>
        <button type="button" pButton icon="pi pi-times" label="Cancel" class="p-button-danger"
            (click)="onCancelPassword()"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Change Role to Disposer" [(visible)]="displayChangeRole" [modal]="true" [closable]="true"
    [style]="{width: '50vw'}" (onHide)="onCancelChangeRole()">
    <div class="p-fluid">
        <form [formGroup]="roleForm">
            <div class="p-field">
                <label for="email">Waste Disposer</label>
                <p-dropdown [options]="disposerDropdownData" [filter]="true" filterBy="label" [showClear]="true"
                    optionLabel="label" optionValue="value" styleClass="w-100" appendTo="body"
                    formControlName="disposerId" placeholder="Please select">
                </p-dropdown>
                <div *ngIf="roleForm.get('disposerId').invalid && roleForm.get('disposerId').touched">
                    <small class="p-error" *ngIf="roleForm.get('disposerId').errors.required">Please select
                        Disposer</small>
                </div>
            </div>
        </form>
    </div>
    <p-footer>
        <button type="submit" pButton icon="pi pi-check" label="Comfirm" [disabled]="roleForm.invalid"
            (click)="onSubmitChangeRole()"></button>
        <button type="button" pButton icon="pi pi-times" label="Cancel" class="p-button-danger"
            (click)="onCancelChangeRole()"></button>
    </p-footer>
</p-dialog>

<p-toast></p-toast>